export default {
  // Page titles
  'pages.device.register.title': 'Device Terminal',
  'pages.device.register.subtitle':
    'Manage POS device authorization, binding and BIR tax compliance info',

  // Statistics
  'pages.device.register.stat.total': 'Total Devices',
  'pages.device.register.stat.online': 'Online Devices',
  'pages.device.register.stat.offline': 'Offline Devices',
  'pages.device.register.stat.compliant': 'Compliant Devices',
  'pages.device.register.stat.onlineRate': 'Online Rate',

  // Buttons
  'pages.device.register.export': 'Export',
  'pages.device.register.registerDevice': 'Register Device',
  'pages.device.register.copy': 'Copy',
  'pages.device.register.edit': 'Edit',
  'pages.device.register.save': 'Save',
  'pages.device.register.cancel': 'Cancel',
  'pages.device.register.confirm': 'Confirm',
  'pages.device.register.back': 'Back',

  // Messages
  'pages.device.register.message.exportDeveloping':
    'Export feature is under development...',
  'pages.device.register.exportFileName': 'Device List',
  'pages.device.register.message.exportSuccess': 'Exported successfully',
  'pages.device.register.message.exportFailed': 'Export failed',
  'pages.device.register.message.wrongPassword': 'Incorrect password',
  'pages.device.register.message.deleteSuccess': 'Deleted successfully',
  'pages.device.register.message.deleteFailed': 'Delete failed',
  'pages.device.register.message.registerSuccess': 'Registered successfully',
  'pages.device.register.message.copySuccess': 'Copied successfully',
  'pages.device.register.message.editSuccess': 'Updated successfully',
  'pages.device.register.message.editFailed': 'Update failed',
  'pages.device.register.message.fetchStoreFailed':
    'Failed to fetch store list',

  // Delete modal
  'pages.device.register.deleteConfirm': 'Delete Confirmation',
  'pages.device.register.deleteConfirmText':
    'Please enter password to confirm deletion:',
  'pages.device.register.deletePasswordPlaceholder': 'Enter password',

  // Search
  'pages.device.register.search.placeholder':
    'Search device name, serial number (SN)',

  // Common labels
  'pages.device.register.deviceId': 'Device ID',
  'pages.device.register.deviceName': 'Device Name',
  'pages.device.register.deviceType': 'Device Type',
  'pages.device.register.store': 'Store',
  'pages.device.register.tenant': 'Tenant',
  'pages.device.register.snCode': 'Serial Number',
  'pages.device.register.activationStatus': 'Activation Status',
  'pages.device.register.activationCode': 'Activation Code',
  'pages.device.register.onlineStatus': 'Online Status',
  'pages.device.register.onlineStatus.online': 'Online',
  'pages.device.register.onlineStatus.offline': 'Offline',
  'pages.device.register.expireDate': 'Expiry Date',
  'pages.device.register.terminalNo': 'Terminal No.',

  // Table columns (unique)
  'pages.device.register.column.deviceCode': 'Hardware Code',
  'pages.device.register.column.os': 'OS',
  'pages.device.register.column.expiryDays': 'Expiry Days',
  'pages.device.register.column.action': 'Action',
  'pages.device.register.column.bappBound': 'B-App Bound',
  'pages.device.register.column.version': 'Version',
  'pages.device.register.tag.bound': 'Bound {date}',
  'pages.device.register.tag.unbound': 'Unbound',

  // Unbind BAPP
  'pages.device.register.message.unbindBappSuccess':
    'B-App unbound successfully',
  'pages.device.register.message.unbindBappFailed': 'Failed to unbind B-App',
  'pages.device.register.unbindBapp.title': 'Unbind B-App',
  'pages.device.register.unbindBapp.confirm': 'Confirm Unbind',
  'pages.device.register.unbindBapp.cancel': 'Cancel',
  'pages.device.register.unbindBapp.warning':
    'Device {name} is bound to B-App (SN: {sn}). After unbinding, this B-App will no longer work. Continue?',

  // Dividers
  'pages.device.register.divider.basicInfo': 'Basic Information',
  'pages.device.register.divider.otherInfo': 'Other Information',

  // Form - common
  'pages.device.register.form.input': 'Please enter',
  'pages.device.register.form.select': 'Please select',
  'pages.device.register.form.selectDate': 'Please select',

  // Form - validation & placeholders
  'pages.device.register.form.tenantPlaceholder': 'Select tenant',
  'pages.device.register.form.tenantRequired': 'Please select a tenant',
  'pages.device.register.form.storePlaceholder': 'Select store',
  'pages.device.register.form.storePlaceholderDisabled': 'Select tenant first',
  'pages.device.register.form.storeRequired': 'Please select a store',
  'pages.device.register.form.deviceNameRequired': 'Please enter device name',
  'pages.device.register.form.deviceNamePlaceholder': 'e.g. Front POS 01',
  'pages.device.register.form.deviceTypeRequired': 'Please select device type',
  'pages.device.register.form.expireDatePlaceholder': 'Select expiry date',
  'pages.device.register.form.expireDatePlaceholderEdit':
    'Select authorization end date',
  'pages.device.register.form.expireDateRequired': 'Please select expiry date',
  'pages.device.register.form.expireDateValidator':
    'Expiry date cannot be earlier than today',
  'pages.device.register.form.expireDateTooltip':
    'Defaults to tenant subscription expiry date',
  'pages.device.register.form.terminalNoRequired':
    'Please enter terminal number',

  // Form - other info labels
  'pages.device.register.minNo': 'MIN Number',
  'pages.device.register.ptuNo': 'PTU Number',
  'pages.device.register.issueDate': 'Issue Date',
  'pages.device.register.accNo': 'Accreditation No.',
  'pages.device.register.softwareName': 'Software Name',

  // Detail modal
  'pages.device.register.detail.title': 'Device Details',
  'pages.device.register.detail.basicInfo': 'Basic Information',
  'pages.device.register.detail.ptuInfo': 'PTU Information',

  // Sign credential block (device-sign-v2 §11: status/version/issued/last used/recent enroll attempts)
  'pages.device.register.sign.sectionTitle': 'Sign Credential (v2)',
  'pages.device.register.sign.sectionNote':
    'Credential operations require the Device Registration permission (device:register)',
  'pages.device.register.sign.status': 'Credential Status',
  'pages.device.register.sign.status.active': 'Active',
  'pages.device.register.sign.status.revoked': 'Revoked',
  'pages.device.register.sign.status.none': 'Not Enrolled (No Credential)',
  'pages.device.register.sign.signVersion': 'Sign Version',
  'pages.device.register.sign.issuedAt': 'Issued At',
  'pages.device.register.sign.lastUsedAt': 'Last Used',
  'pages.device.register.sign.lastUsedAt.never': 'Never Used (Stall Red Flag)',
  'pages.device.register.sign.revokedAt': 'Revoked At',
  'pages.device.register.sign.attempts.title':
    'Recent Enroll Attempts (Up to 20)',
  'pages.device.register.sign.attempts.empty': 'No enroll attempts yet',
  'pages.device.register.sign.attempts.result': 'Result',
  'pages.device.register.sign.attempts.clientIp': 'Source IP',
  'pages.device.register.sign.attempts.createTime': 'Arrival Time',
  // Enroll final states (closed set, aligned with backend audit result)
  'pages.device.register.sign.attempts.result.ISSUED': 'Issued',
  'pages.device.register.sign.attempts.result.NOT_FOUND': 'Device Not Found',
  'pages.device.register.sign.attempts.result.CODE_WRONG':
    'Wrong Activation Code',
  'pages.device.register.sign.attempts.result.NOT_ACTIVATED': 'Not Activated',
  'pages.device.register.sign.attempts.result.DISABLED': 'Device Disabled',
  'pages.device.register.sign.attempts.result.DUP_CODE': 'Device Code Conflict',
  'pages.device.register.sign.attempts.result.CONFLICT':
    'Credential Conflict (Evict Required)',
  'pages.device.register.sign.attempts.result.RATE_LIMITED': 'Rate Limited',

  // Evict (new code + revoke; strictly distinguished from "Reset Activation Code" and "Revoke Credential", §4 v10)
  'pages.device.register.sign.evict': 'Evict (New Code + Revoke)',
  'pages.device.register.sign.evict.confirmTitle': 'Confirm Eviction',
  'pages.device.register.sign.evict.confirmDesc':
    'This will evict the device: ① activation status resets to "not activated" and the device code is cleared; ② the sign credential is revoked; ③ a brand-new activation code is generated (shown only once). The device must re-activate with the new code and enroll again. Continue?',
  'pages.device.register.sign.evict.legacyDisabled':
    'Legacy formula-code devices (id ≤ 900000) do not support eviction; disable the device and rebind a new one instead',
  'pages.device.register.sign.evict.resultTitle':
    'Eviction Completed — New Activation Code',
  'pages.device.register.sign.evict.newCode': 'New Activation Code',
  'pages.device.register.sign.evict.offlineGuide':
    'Deliver the new activation code to the installer out-of-band (shown only once in this response); the device must re-activate with the new code and complete enrollment.',
  'pages.device.register.sign.evict.revokePending':
    'Half-failure: credential revocation is incomplete (revokePending) — the credential is already unusable because the device is back to "not activated"; file a ticket for ops to follow up and clean up the residual credential row.',
  'pages.device.register.sign.evict.acknowledged':
    'Recorded & Delivered Out-of-Band',

  // Revoke credential (revoke-only; double confirmation + stolen-device guidance to evict instead, §11/§17)
  'pages.device.register.sign.revoke': 'Revoke Credential',
  'pages.device.register.sign.revoke.continue': 'Continue',
  'pages.device.register.sign.revoke.confirmRevoke': 'Confirm Revoke',
  'pages.device.register.sign.revoke.confirmTitle': 'Revoke Credential',
  'pages.device.register.sign.revoke.confirmDesc':
    'Revoke-only: the device sign credential is revoked — the activation code is NOT changed and no secret is re-issued; the device recovers by clearing its local credential and re-enrolling.',
  'pages.device.register.sign.revoke.stolenGuide':
    'If the device is lost or stolen, use "Evict (New Code + Revoke)" instead: a stolen device keeps its activation code locally and will re-enroll itself via the auto-issuance channel after REVOKED — revoke-only cannot evict a stolen device.',
  'pages.device.register.sign.revoke.finalTitle': 'Confirm Again',
  'pages.device.register.sign.revoke.finalDesc':
    "Revoke this device's sign credential? Signed requests from the device will be rejected until it re-enrolls.",
  'pages.device.register.sign.revoke.disabled.none':
    'Device has not enrolled; no credential to revoke',
  'pages.device.register.sign.revoke.disabled.revoked':
    'Credential is already revoked',

  // Remote sign repair (SIGN_RESET ops command, 2026-10-16 sign self-heal; F2c)
  'pages.device.register.sign.reset': 'Remote Sign Repair',
  'pages.device.register.sign.reset.modalTitle':
    'Remote Sign Repair (SIGN_RESET)',
  'pages.device.register.sign.reset.confirmDesc':
    'A sign-repair ops command will be issued to this device: it is claimed and executed on the next poll, then the device re-enrolls its sign credential and reports the result; signed requests may fail briefly during execution. Verify the device above before confirming.',
  'pages.device.register.sign.reset.submit': 'Issue Command',
  'pages.device.register.sign.reset.mode': 'Repair mode',
  'pages.device.register.sign.reset.mode.reEnroll':
    'Re-enroll credential (clear local credential then re-enroll; activation untouched; only for cases where the server no longer holds a credential)',
  'pages.device.register.sign.reset.mode.reactivate':
    'Full re-activation (re-run activate with the local activation code, revoking the old credential, then re-enroll; the correct command for 464 / credential-conflict scenarios)',
  'pages.device.register.sign.reset.activeCredentialHint':
    'An active credential exists on the server; keep the default full re-activation. Re-enrolling the credential will be rejected by the device terminal-state guard.',
  'pages.device.register.sign.reset.reason': 'Reason',
  'pages.device.register.sign.reset.reasonRequired':
    'Reason is required (for audit)',
  'pages.device.register.sign.reset.reasonPlaceholder':
    '≤200 chars, kept on the command for audit (e.g. persistent 401 / broken signature, remote repair)',
  'pages.device.register.sign.reset.sent':
    'Command issued; it takes effect on the device next poll (worst case ~5 min at the default interval)',
  'pages.device.register.sign.reset.disabled.none':
    'Device has not enrolled (no credential): the next enroll auto-issues a new credential; remote repair is unnecessary',
  'pages.device.register.sign.reset.disabled.notActivated':
    'Device is not activated; remote sign repair is unavailable (activate the device first)',
  'pages.device.register.sign.reset.disabled.noPerm':
    'No remote ops permission (ops:deviceOps); cannot issue ops commands',

  // Edit modal
  'pages.device.register.editTitle': 'Edit Device',

  // Add modal
  'pages.device.register.addTitle': 'Register Device',
};
